import { getData } from "./api";
import { isEmpty } from "lodash";
import settings from "./settings";

const learnMoreMap = {
  "Main Street": {
    "Payor & Provider": {
      Hospital: {
        folder: "Main Street - Payor & Provider - Hospitals/",
        Pharma: {
          images: [
            "LifeCycleInsightsBiologicsPharma.png",
            "LifeCycleInsightsBiologicsPharma2.png",
            "LifeCycleInsightsBiologicsPharma3.png",
            "LifeCycleInsightsBiologicsPharma4.png",
            "LifeCycleInsightsBiologicsPharma5.png",
            "LifeCycleInsightsBiologicsPharma6.png",
            "LifeCycleInsightsBiologicsPharma7.png",
            "LifeCycleInsightsBiologicsPharma8.png",
            "LifeCycleInsightsBiologicsPharma9.png",
            "LifeCycleInsightsBiologicsPharma10.png",
            "LifeCycleInsightsBiologicsPharma11.png",
            "LifeCycleInsightsBiologicsPharma12.png",
            "LifeCycleInsightsBiologicsPharma13.png",
          ],
          brochures: [
            {
              path: "IPDAnalytics_LifeCycleInsights.pdf",
              name: "Full",
            },
            ...new Array(11).fill(null),
            {
              path: "IPDAnalytics_LifeCycleInsights.pdf",
              name: "Full",
            },
          ],
          podcasts: [
            ...new Array(3).fill(null),
            {
              path:
                "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?id=Introduction to Canadian Patent and Regulatory System&type=mp3",
              name: "Intro to Canada",
            },
            {
              path:
                "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?id=Introduction to Japanese Patent and Regulatory System&type=mp3",
              name: "Intro to Japan",
            },
            {
              path:
                "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?id=Introduction to Brazilian Patent and Regulatory System&type=mp3",
              name: "Intro to Brazil",
            },
            ...new Array(2).fill(null),
            {
              path: "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?type=mp3&id=Introduction%20to%20Indian%20Patent%20and%20Regulatory%20System",
              name: "Intro to India",
            },
            {
              path: "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?type=mp3&id=Introduction%20to%20Korean%20Patent%20and%20Regulatory%20System",
              name: "Intro to Korea",
            },
            {
              path: "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?type=mp3&id=Introduction%20to%20Chinese%20Patent%20and%20Regulatory%20System",
              name: "Intro to China",
            },
            ...new Array(2).fill(null),
          ],
        },
        Biologics: {
          images: [
            "LifeCycleInsightsBiologicsPharma.png",
            "LifeCycleInsightsBiologicsPharma2.png",
            "LifeCycleInsightsBiologicsPharma3.png",
            "LifeCycleInsightsBiologicsPharma4.png",
            "LifeCycleInsightsBiologicsPharma5.png",
            "LifeCycleInsightsBiologicsPharma6.png",
            "LifeCycleInsightsBiologicsPharma7.png",
            "LifeCycleInsightsBiologicsPharma8.png",
            "LifeCycleInsightsBiologicsPharma9.png",
            "LifeCycleInsightsBiologicsPharma10.png",
            "LifeCycleInsightsBiologicsPharma11.png",
            "LifeCycleInsightsBiologicsPharma12.png",
            "LifeCycleInsightsBiologicsPharma13.png",
          ],
          brochures: [
            {
              path: "IPDAnalytics_LifeCycleInsights.pdf",
              name: "Full",
            },
            ...new Array(11).fill(null),
            {
              path: "IPDAnalytics_LifeCycleInsights.pdf",
              name: "Full",
            },
          ],
          podcasts: [
            ...new Array(3).fill(null),
            {
              path:
                "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?id=Introduction to Canadian Patent and Regulatory System&type=mp3",
              name: "Intro to Canada",
            },
            {
              path:
                "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?id=Introduction to Japanese Patent and Regulatory System&type=mp3",
              name: "Intro to Japan",
            },
            {
              path:
                "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?id=Introduction to Brazilian Patent and Regulatory System&type=mp3",
              name: "Intro to Brazil",
            },
            ...new Array(2).fill(null),
            {
              path: "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?type=mp3&id=Introduction%20to%20Indian%20Patent%20and%20Regulatory%20System",
              name: "Intro to India",
            },
            {
              path: "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?type=mp3&id=Introduction%20to%20Korean%20Patent%20and%20Regulatory%20System",
              name: "Intro to Korea",
            },
            {
              path: "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?type=mp3&id=Introduction%20to%20Chinese%20Patent%20and%20Regulatory%20System",
              name: "Intro to China",
            },
            ...new Array(2).fill(null),
          ],
        },
        "Payor & Provider": {
          images: ["ProviderPayorandProviderInsights.png"],
          brochures: ["IPDAnalytics_Providers_PayorandProviderInsights.pdf"],
        },
        "Payer & Provider": {
          images: ["ProviderPayorandProviderInsights.png"],
          brochures: ["IPDAnalytics_Providers_PayorandProviderInsights.pdf"],
        },
        Forecasting: {
          images: [
            "ForecastingPopups1.png",
            "ForecastingPopups2.png",
            "ForecastingPopups3.png",
            "ForecastingPopups4.png",
            "ForecastingPopups5.png",
          ],
          brochures: ["IPDAnalytics_MarketandFinancialInsightsBrochure.pdf"],
        },
        "Coding & Reimbursement": {
          images: [
            "ProviderCODESOURxCE.png",
            "ProviderCODESOURxCE2.png",
            "ProviderCODESOURxCE3.png",
            "ProviderCODESOURxCE4.png",
            "ProviderCODESOURxCE5.png",
          ],
          brochures: ["IPDAnalytics_Providers_CODESOURxCE.pdf"],
        },
        "Budget Impact": {
          images: [
            "BudgetImpactPopups1.png",
            "BudgetImpactPopups2.png",
            "BudgetImpactPopups3.png",
            "BudgetImpactPopups4.png",
          ],
          brochures: ["IPDAnalytics_BudgetImpact.pdf"],
        },
      },
      "Managed Care": {
        folder: "Main Street - Payor & Provider - Managed Care and PBM/",
        Pharma: {
          images: [
            "PayorsandProvidersLifeCycleInsightsPharma.png",
            "PayorsandProvidersLifeCycleInsightsPharma2.png",
          ],
          brochures: [
            "IPDAnalytics_PayorsandProviders_USLifeCycleInsightsPharma.pdf",
            "IPDAnalytics_GlobalLifeCycleInsightsPharma.pdf",
          ],
        },
        Biologics: {
          images: ["PayorsandProvidersLifeCycleInsightsBiologics.png"],
          brochures: [
            "IPDAnalytics_PayorsandProviders_USandGlobalLifeCycleInsightsBiosimilars.pdf",
          ],
        },
        "Payor & Provider": {
          images: ["PayorsPayorandProviderInsights.png"],
          brochures: ["IPDAnalytics_Payors_PayorandProviderInsights.pdf"],
        },
        "Payer & Provider": {
          images: ["PayorsPayorandProviderInsights.png"],
          brochures: ["IPDAnalytics_Payors_PayorandProviderInsights.pdf"],
        },
        Forecasting: {
          images: [
            "ForecastingPopups1.png",
            "ForecastingPopups2.png",
            "ForecastingPopups3.png",
            "ForecastingPopups4.png",
            "ForecastingPopups5.png",
          ],
          brochures: ["IPDAnalytics_MarketandFinancialInsightsBrochure.pdf"],
        },
        "Coding & Reimbursement": {
          images: [
            "PayorsCODESOURxCE.png",
            "PayorsCODESOURxCE2.png",
            "PayorsCODESOURxCE3.png",
            "PayorsCODESOURxCE4.png",
          ],
          brochures: ["IPDAnalytics_Payors_CODESOURxCE.pdf"],
        },
        "Budget Impact": {
          images: [
            "BudgetImpactPopups1.png",
            "BudgetImpactPopups2.png",
            "BudgetImpactPopups3.png",
            "BudgetImpactPopups4.png",
          ],
          brochures: ["IPDAnalytics_BudgetImpact.pdf"],
        },
      },
      PBM: {
        folder: "Main Street - Payor & Provider - Managed Care and PBM/",
        Pharma: {
          images: [
            "LifeCycleInsightsBiologicsPharma.png",
            "LifeCycleInsightsBiologicsPharma2.png",
            "LifeCycleInsightsBiologicsPharma3.png",
            "LifeCycleInsightsBiologicsPharma4.png",
            "LifeCycleInsightsBiologicsPharma5.png",
            "LifeCycleInsightsBiologicsPharma6.png",
            "LifeCycleInsightsBiologicsPharma7.png",
            "LifeCycleInsightsBiologicsPharma8.png",
            "LifeCycleInsightsBiologicsPharma9.png",
            "LifeCycleInsightsBiologicsPharma10.png",
            "LifeCycleInsightsBiologicsPharma11.png",
            "LifeCycleInsightsBiologicsPharma12.png",
            "LifeCycleInsightsBiologicsPharma13.png",
          ],
          brochures: [
            {
              path: "IPDAnalytics_LifeCycleInsights.pdf",
              name: "Full",
            },
            ...new Array(11).fill(null),
            {
              path: "IPDAnalytics_LifeCycleInsights.pdf",
              name: "Full",
            },
          ],
          podcasts: [
            ...new Array(3).fill(null),
            {
              path:
                "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?id=Introduction to Canadian Patent and Regulatory System&type=mp3",
              name: "Intro to Canada",
            },
            {
              path:
                "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?id=Introduction to Japanese Patent and Regulatory System&type=mp3",
              name: "Intro to Japan",
            },
            {
              path:
                "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?id=Introduction to Brazilian Patent and Regulatory System&type=mp3",
              name: "Intro to Brazil",
            },
            ...new Array(2).fill(null),
            {
              path: "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?type=mp3&id=Introduction%20to%20Indian%20Patent%20and%20Regulatory%20System",
              name: "Intro to India",
            },
            {
              path: "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?type=mp3&id=Introduction%20to%20Korean%20Patent%20and%20Regulatory%20System",
              name: "Intro to Korea",
            },
            {
              path: "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?type=mp3&id=Introduction%20to%20Chinese%20Patent%20and%20Regulatory%20System",
              name: "Intro to China",
            },
            ...new Array(2).fill(null),
          ],
        },
        Biologics: {
          images: [
            "LifeCycleInsightsBiologicsPharma.png",
            "LifeCycleInsightsBiologicsPharma2.png",
            "LifeCycleInsightsBiologicsPharma3.png",
            "LifeCycleInsightsBiologicsPharma4.png",
            "LifeCycleInsightsBiologicsPharma5.png",
            "LifeCycleInsightsBiologicsPharma6.png",
            "LifeCycleInsightsBiologicsPharma7.png",
            "LifeCycleInsightsBiologicsPharma8.png",
            "LifeCycleInsightsBiologicsPharma9.png",
            "LifeCycleInsightsBiologicsPharma10.png",
            "LifeCycleInsightsBiologicsPharma11.png",
            "LifeCycleInsightsBiologicsPharma12.png",
            "LifeCycleInsightsBiologicsPharma13.png",
          ],
          brochures: [
            {
              path: "IPDAnalytics_LifeCycleInsights.pdf",
              name: "Full",
            },
            ...new Array(11).fill(null),
            {
              path: "IPDAnalytics_LifeCycleInsights.pdf",
              name: "Full",
            },
          ],
          podcasts: [
            ...new Array(3).fill(null),
            {
              path:
                "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?id=Introduction to Canadian Patent and Regulatory System&type=mp3",
              name: "Intro to Canada",
            },
            {
              path:
                "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?id=Introduction to Japanese Patent and Regulatory System&type=mp3",
              name: "Intro to Japan",
            },
            {
              path:
                "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?id=Introduction to Brazilian Patent and Regulatory System&type=mp3",
              name: "Intro to Brazil",
            },
            ...new Array(2).fill(null),
            {
              path: "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?type=mp3&id=Introduction%20to%20Indian%20Patent%20and%20Regulatory%20System",
              name: "Intro to India",
            },
            {
              path: "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?type=mp3&id=Introduction%20to%20Korean%20Patent%20and%20Regulatory%20System",
              name: "Intro to Korea",
            },
            {
              path: "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?type=mp3&id=Introduction%20to%20Chinese%20Patent%20and%20Regulatory%20System",
              name: "Intro to China",
            },
            ...new Array(2).fill(null),
          ],
        },
        "Payor & Provider": {
          images: ["PayorsPayorandProviderInsights.png"],
          brochures: ["IPDAnalytics_Payors_PayorandProviderInsights.pdf"],
        },
        "Payer & Provider": {
          images: ["PayorsPayorandProviderInsights.png"],
          brochures: ["IPDAnalytics_Payors_PayorandProviderInsights.pdf"],
        },
        Forecasting: {
          images: [
            "ForecastingPopups1.png",
            "ForecastingPopups2.png",
            "ForecastingPopups3.png",
            "ForecastingPopups4.png",
            "ForecastingPopups5.png",
          ],
          brochures: ["IPDAnalytics_MarketandFinancialInsightsBrochure.pdf"],
        },
        "Coding & Reimbursement": {
          images: [
            "PayorsCODESOURxCE.png",
            "PayorsCODESOURxCE2.png",
            "PayorsCODESOURxCE3.png",
            "PayorsCODESOURxCE4.png",
          ],
          brochures: ["IPDAnalytics_Payors_CODESOURxCE.pdf"],
        },
        "Budget Impact": {
          images: [
            "BudgetImpactPopups1.png",
            "BudgetImpactPopups2.png",
            "BudgetImpactPopups3.png",
            "BudgetImpactPopups4.png",
          ],
          brochures: ["IPDAnalytics_BudgetImpact.pdf"],
        },
      },
    },
    "Payer & Provider": {
      Hospital: {
        folder: "Main Street - Payor & Provider - Hospitals/",
        Pharma: {
          images: [
            "LifeCycleInsightsBiologicsPharma.png",
            "LifeCycleInsightsBiologicsPharma2.png",
            "LifeCycleInsightsBiologicsPharma3.png",
            "LifeCycleInsightsBiologicsPharma4.png",
            "LifeCycleInsightsBiologicsPharma5.png",
            "LifeCycleInsightsBiologicsPharma6.png",
            "LifeCycleInsightsBiologicsPharma7.png",
            "LifeCycleInsightsBiologicsPharma8.png",
            "LifeCycleInsightsBiologicsPharma9.png",
            "LifeCycleInsightsBiologicsPharma10.png",
            "LifeCycleInsightsBiologicsPharma11.png",
            "LifeCycleInsightsBiologicsPharma12.png",
            "LifeCycleInsightsBiologicsPharma13.png",
          ],
          brochures: [
            {
              path: "IPDAnalytics_LifeCycleInsights.pdf",
              name: "Full",
            },
            ...new Array(11).fill(null),
            {
              path: "IPDAnalytics_LifeCycleInsights.pdf",
              name: "Full",
            },
          ],
          podcasts: [
            ...new Array(3).fill(null),
            {
              path:
                "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?id=Introduction to Canadian Patent and Regulatory System&type=mp3",
              name: "Intro to Canada",
            },
            {
              path:
                "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?id=Introduction to Japanese Patent and Regulatory System&type=mp3",
              name: "Intro to Japan",
            },
            {
              path:
                "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?id=Introduction to Brazilian Patent and Regulatory System&type=mp3",
              name: "Intro to Brazil",
            },
            ...new Array(2).fill(null),
            {
              path: "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?type=mp3&id=Introduction%20to%20Indian%20Patent%20and%20Regulatory%20System",
              name: "Intro to India",
            },
            {
              path: "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?type=mp3&id=Introduction%20to%20Korean%20Patent%20and%20Regulatory%20System",
              name: "Intro to Korea",
            },
            {
              path: "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?type=mp3&id=Introduction%20to%20Chinese%20Patent%20and%20Regulatory%20System",
              name: "Intro to China",
            },
            ...new Array(2).fill(null),
          ],
        },
        Biologics: {
          images: [
            "LifeCycleInsightsBiologicsPharma.png",
            "LifeCycleInsightsBiologicsPharma2.png",
            "LifeCycleInsightsBiologicsPharma3.png",
            "LifeCycleInsightsBiologicsPharma4.png",
            "LifeCycleInsightsBiologicsPharma5.png",
            "LifeCycleInsightsBiologicsPharma6.png",
            "LifeCycleInsightsBiologicsPharma7.png",
            "LifeCycleInsightsBiologicsPharma8.png",
            "LifeCycleInsightsBiologicsPharma9.png",
            "LifeCycleInsightsBiologicsPharma10.png",
            "LifeCycleInsightsBiologicsPharma11.png",
            "LifeCycleInsightsBiologicsPharma12.png",
            "LifeCycleInsightsBiologicsPharma13.png",
          ],
          brochures: [
            {
              path: "IPDAnalytics_LifeCycleInsights.pdf",
              name: "Full",
            },
            ...new Array(11).fill(null),
            {
              path: "IPDAnalytics_LifeCycleInsights.pdf",
              name: "Full",
            },
          ],
          podcasts: [
            ...new Array(3).fill(null),
            {
              path:
                "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?id=Introduction to Canadian Patent and Regulatory System&type=mp3",
              name: "Intro to Canada",
            },
            {
              path:
                "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?id=Introduction to Japanese Patent and Regulatory System&type=mp3",
              name: "Intro to Japan",
            },
            {
              path:
                "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?id=Introduction to Brazilian Patent and Regulatory System&type=mp3",
              name: "Intro to Brazil",
            },
            ...new Array(2).fill(null),
            {
              path: "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?type=mp3&id=Introduction%20to%20Indian%20Patent%20and%20Regulatory%20System",
              name: "Intro to India",
            },
            {
              path: "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?type=mp3&id=Introduction%20to%20Korean%20Patent%20and%20Regulatory%20System",
              name: "Intro to Korea",
            },
            {
              path: "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?type=mp3&id=Introduction%20to%20Chinese%20Patent%20and%20Regulatory%20System",
              name: "Intro to China",
            },
            ...new Array(2).fill(null),
          ],
        },
        "Payor & Provider": {
          images: ["ProviderPayorandProviderInsights.png"],
          brochures: ["IPDAnalytics_Providers_PayorandProviderInsights.pdf"],
        },
        "Payer & Provider": {
          images: ["ProviderPayorandProviderInsights.png"],
          brochures: ["IPDAnalytics_Providers_PayorandProviderInsights.pdf"],
        },
        Forecasting: {
          images: [
            "ForecastingPopups1.png",
            "ForecastingPopups2.png",
            "ForecastingPopups3.png",
            "ForecastingPopups4.png",
            "ForecastingPopups5.png",
          ],
          brochures: ["IPDAnalytics_MarketandFinancialInsightsBrochure.pdf"],
        },
        "Coding & Reimbursement": {
          images: [
            "ProviderCODESOURxCE.png",
            "ProviderCODESOURxCE2.png",
            "ProviderCODESOURxCE3.png",
            "ProviderCODESOURxCE4.png",
            "ProviderCODESOURxCE5.png",
          ],
          brochures: ["IPDAnalytics_Providers_CODESOURxCE.pdf"],
        },
        "Budget Impact": {
          images: [
            "BudgetImpactPopups1.png",
            "BudgetImpactPopups2.png",
            "BudgetImpactPopups3.png",
            "BudgetImpactPopups4.png",
          ],
          brochures: ["IPDAnalytics_BudgetImpact.pdf"],
        },
      },
      "Managed Care": {
        folder: "Main Street - Payor & Provider - Managed Care and PBM/",
        Pharma: {
          images: [
            "LifeCycleInsightsBiologicsPharma.png",
            "LifeCycleInsightsBiologicsPharma2.png",
            "LifeCycleInsightsBiologicsPharma3.png",
            "LifeCycleInsightsBiologicsPharma4.png",
            "LifeCycleInsightsBiologicsPharma5.png",
            "LifeCycleInsightsBiologicsPharma6.png",
            "LifeCycleInsightsBiologicsPharma7.png",
            "LifeCycleInsightsBiologicsPharma8.png",
            "LifeCycleInsightsBiologicsPharma9.png",
            "LifeCycleInsightsBiologicsPharma10.png",
            "LifeCycleInsightsBiologicsPharma11.png",
            "LifeCycleInsightsBiologicsPharma12.png",
            "LifeCycleInsightsBiologicsPharma13.png",
          ],
          brochures: [
            {
              path: "IPDAnalytics_LifeCycleInsights.pdf",
              name: "Full",
            },
            ...new Array(11).fill(null),
            {
              path: "IPDAnalytics_LifeCycleInsights.pdf",
              name: "Full",
            },
          ],
          podcasts: [
            ...new Array(3).fill(null),
            {
              path:
                "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?id=Introduction to Canadian Patent and Regulatory System&type=mp3",
              name: "Intro to Canada",
            },
            {
              path:
                "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?id=Introduction to Japanese Patent and Regulatory System&type=mp3",
              name: "Intro to Japan",
            },
            {
              path:
                "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?id=Introduction to Brazilian Patent and Regulatory System&type=mp3",
              name: "Intro to Brazil",
            },
            ...new Array(2).fill(null),
            {
              path: "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?type=mp3&id=Introduction%20to%20Indian%20Patent%20and%20Regulatory%20System",
              name: "Intro to India",
            },
            {
              path: "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?type=mp3&id=Introduction%20to%20Korean%20Patent%20and%20Regulatory%20System",
              name: "Intro to Korea",
            },
            {
              path: "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?type=mp3&id=Introduction%20to%20Chinese%20Patent%20and%20Regulatory%20System",
              name: "Intro to China",
            },
            ...new Array(2).fill(null),
          ],
        },
        Biologics: {
          images: [
            "LifeCycleInsightsBiologicsPharma.png",
            "LifeCycleInsightsBiologicsPharma2.png",
            "LifeCycleInsightsBiologicsPharma3.png",
            "LifeCycleInsightsBiologicsPharma4.png",
            "LifeCycleInsightsBiologicsPharma5.png",
            "LifeCycleInsightsBiologicsPharma6.png",
            "LifeCycleInsightsBiologicsPharma7.png",
            "LifeCycleInsightsBiologicsPharma8.png",
            "LifeCycleInsightsBiologicsPharma9.png",
            "LifeCycleInsightsBiologicsPharma10.png",
            "LifeCycleInsightsBiologicsPharma11.png",
            "LifeCycleInsightsBiologicsPharma12.png",
            "LifeCycleInsightsBiologicsPharma13.png",
          ],
          brochures: [
            {
              path: "IPDAnalytics_LifeCycleInsights.pdf",
              name: "Full",
            },
            ...new Array(11).fill(null),
            {
              path: "IPDAnalytics_LifeCycleInsights.pdf",
              name: "Full",
            },
          ],
          podcasts: [
            ...new Array(3).fill(null),
            {
              path:
                "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?id=Introduction to Canadian Patent and Regulatory System&type=mp3",
              name: "Intro to Canada",
            },
            {
              path:
                "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?id=Introduction to Japanese Patent and Regulatory System&type=mp3",
              name: "Intro to Japan",
            },
            {
              path:
                "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?id=Introduction to Brazilian Patent and Regulatory System&type=mp3",
              name: "Intro to Brazil",
            },
            ...new Array(2).fill(null),
            {
              path: "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?type=mp3&id=Introduction%20to%20Indian%20Patent%20and%20Regulatory%20System",
              name: "Intro to India",
            },
            {
              path: "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?type=mp3&id=Introduction%20to%20Korean%20Patent%20and%20Regulatory%20System",
              name: "Intro to Korea",
            },
            {
              path: "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?type=mp3&id=Introduction%20to%20Chinese%20Patent%20and%20Regulatory%20System",
              name: "Intro to China",
            },
            ...new Array(2).fill(null),
          ],
        },
        "Payor & Provider": {
          images: ["PayorsPayorandProviderInsights.png"],
          brochures: ["IPDAnalytics_Payors_PayorandProviderInsights.pdf"],
        },
        "Payer & Provider": {
          images: ["PayorsPayorandProviderInsights.png"],
          brochures: ["IPDAnalytics_Payors_PayorandProviderInsights.pdf"],
        },
        Forecasting: {
          images: [
            "ForecastingPopups1.png",
            "ForecastingPopups2.png",
            "ForecastingPopups3.png",
            "ForecastingPopups4.png",
            "ForecastingPopups5.png",
          ],
          brochures: ["IPDAnalytics_MarketandFinancialInsightsBrochure.pdf"],
        },
        "Coding & Reimbursement": {
          images: [
            "PayorsCODESOURxCE.png",
            "PayorsCODESOURxCE2.png",
            "PayorsCODESOURxCE3.png",
            "PayorsCODESOURxCE4.png",
          ],
          brochures: ["IPDAnalytics_Payors_CODESOURxCE.pdf"],
        },
        "Budget Impact": {
          images: [
            "BudgetImpactPopups1.png",
            "BudgetImpactPopups2.png",
            "BudgetImpactPopups3.png",
            "BudgetImpactPopups4.png",
          ],
          brochures: ["IPDAnalytics_BudgetImpact.pdf"],
        },
      },
      PBM: {
        folder: "Main Street - Payor & Provider - Managed Care and PBM/",
        Pharma: {
          images: [
            "LifeCycleInsightsBiologicsPharma.png",
            "LifeCycleInsightsBiologicsPharma2.png",
            "LifeCycleInsightsBiologicsPharma3.png",
            "LifeCycleInsightsBiologicsPharma4.png",
            "LifeCycleInsightsBiologicsPharma5.png",
            "LifeCycleInsightsBiologicsPharma6.png",
            "LifeCycleInsightsBiologicsPharma7.png",
            "LifeCycleInsightsBiologicsPharma8.png",
            "LifeCycleInsightsBiologicsPharma9.png",
            "LifeCycleInsightsBiologicsPharma10.png",
            "LifeCycleInsightsBiologicsPharma11.png",
            "LifeCycleInsightsBiologicsPharma12.png",
            "LifeCycleInsightsBiologicsPharma13.png",
          ],
          brochures: [
            {
              path: "IPDAnalytics_LifeCycleInsights.pdf",
              name: "Full",
            },
            ...new Array(11).fill(null),
            {
              path: "IPDAnalytics_LifeCycleInsights.pdf",
              name: "Full",
            },
          ],
          podcasts: [
            ...new Array(3).fill(null),
            {
              path:
                "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?id=Introduction to Canadian Patent and Regulatory System&type=mp3",
              name: "Intro to Canada",
            },
            {
              path:
                "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?id=Introduction to Japanese Patent and Regulatory System&type=mp3",
              name: "Intro to Japan",
            },
            {
              path:
                "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?id=Introduction to Brazilian Patent and Regulatory System&type=mp3",
              name: "Intro to Brazil",
            },
            ...new Array(2).fill(null),
            {
              path: "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?type=mp3&id=Introduction%20to%20Indian%20Patent%20and%20Regulatory%20System",
              name: "Intro to India",
            },
            {
              path: "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?type=mp3&id=Introduction%20to%20Korean%20Patent%20and%20Regulatory%20System",
              name: "Intro to Korea",
            },
            {
              path: "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?type=mp3&id=Introduction%20to%20Chinese%20Patent%20and%20Regulatory%20System",
              name: "Intro to China",
            },
            ...new Array(2).fill(null),
          ],
        },
        Biologics: {
          images: [
            "LifeCycleInsightsBiologicsPharma.png",
            "LifeCycleInsightsBiologicsPharma2.png",
            "LifeCycleInsightsBiologicsPharma3.png",
            "LifeCycleInsightsBiologicsPharma4.png",
            "LifeCycleInsightsBiologicsPharma5.png",
            "LifeCycleInsightsBiologicsPharma6.png",
            "LifeCycleInsightsBiologicsPharma7.png",
            "LifeCycleInsightsBiologicsPharma8.png",
            "LifeCycleInsightsBiologicsPharma9.png",
            "LifeCycleInsightsBiologicsPharma10.png",
            "LifeCycleInsightsBiologicsPharma11.png",
            "LifeCycleInsightsBiologicsPharma12.png",
            "LifeCycleInsightsBiologicsPharma13.png",
          ],
          brochures: [
            {
              path: "IPDAnalytics_LifeCycleInsights.pdf",
              name: "Full",
            },
            ...new Array(11).fill(null),
            {
              path: "IPDAnalytics_LifeCycleInsights.pdf",
              name: "Full",
            },
          ],
          podcasts: [
            ...new Array(3).fill(null),
            {
              path:
                "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?id=Introduction to Canadian Patent and Regulatory System&type=mp3",
              name: "Intro to Canada",
            },
            {
              path:
                "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?id=Introduction to Japanese Patent and Regulatory System&type=mp3",
              name: "Intro to Japan",
            },
            {
              path:
                "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?id=Introduction to Brazilian Patent and Regulatory System&type=mp3",
              name: "Intro to Brazil",
            },
            ...new Array(2).fill(null),
            {
              path: "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?type=mp3&id=Introduction%20to%20Indian%20Patent%20and%20Regulatory%20System",
              name: "Intro to India",
            },
            {
              path: "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?type=mp3&id=Introduction%20to%20Korean%20Patent%20and%20Regulatory%20System",
              name: "Intro to Korea",
            },
            {
              path: "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?type=mp3&id=Introduction%20to%20Chinese%20Patent%20and%20Regulatory%20System",
              name: "Intro to China",
            },
            ...new Array(2).fill(null),
          ],
        },
        "Payor & Provider": {
          images: ["PayorsPayorandProviderInsights.png"],
          brochures: ["IPDAnalytics_Payors_PayorandProviderInsights.pdf"],
        },
        "Payer & Provider": {
          images: ["PayorsPayorandProviderInsights.png"],
          brochures: ["IPDAnalytics_Payors_PayorandProviderInsights.pdf"],
        },
        Forecasting: {
          images: [
            "ForecastingPopups1.png",
            "ForecastingPopups2.png",
            "ForecastingPopups3.png",
            "ForecastingPopups4.png",
            "ForecastingPopups5.png",
          ],
          brochures: ["IPDAnalytics_MarketandFinancialInsightsBrochure.pdf"],
        },
        "Coding & Reimbursement": {
          images: [
            "PayorsCODESOURxCE.png",
            "PayorsCODESOURxCE2.png",
            "PayorsCODESOURxCE3.png",
            "PayorsCODESOURxCE4.png",
          ],
          brochures: ["IPDAnalytics_Payors_CODESOURxCE.pdf"],
        },
        "Budget Impact": {
          images: [
            "BudgetImpactPopups1.png",
            "BudgetImpactPopups2.png",
            "BudgetImpactPopups3.png",
            "BudgetImpactPopups4.png",
          ],
          brochures: ["IPDAnalytics_BudgetImpact.pdf"],
        },
      },
    },
    "Supply Chain": {
      All: {
        folder: "Main Street - Supply Chain/",
        Pharma: {
          images: [
            "LifeCycleInsightsBiologicsPharma.png",
            "LifeCycleInsightsBiologicsPharma2.png",
            "LifeCycleInsightsBiologicsPharma3.png",
            "LifeCycleInsightsBiologicsPharma4.png",
            "LifeCycleInsightsBiologicsPharma5.png",
            "LifeCycleInsightsBiologicsPharma6.png",
            "LifeCycleInsightsBiologicsPharma7.png",
            "LifeCycleInsightsBiologicsPharma8.png",
            "LifeCycleInsightsBiologicsPharma9.png",
            "LifeCycleInsightsBiologicsPharma10.png",
            "LifeCycleInsightsBiologicsPharma11.png",
            "LifeCycleInsightsBiologicsPharma12.png",
            "LifeCycleInsightsBiologicsPharma13.png",
          ],
          brochures: [
            {
              path: "IPDAnalytics_LifeCycleInsights.pdf",
              name: "Full",
            },
            ...new Array(11).fill(null),
            {
              path: "IPDAnalytics_LifeCycleInsights.pdf",
              name: "Full",
            },
          ],
          podcasts: [
            ...new Array(3).fill(null),
            {
              path:
                "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?id=Introduction to Canadian Patent and Regulatory System&type=mp3",
              name: "Intro to Canada",
            },
            {
              path:
                "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?id=Introduction to Japanese Patent and Regulatory System&type=mp3",
              name: "Intro to Japan",
            },
            {
              path:
                "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?id=Introduction to Brazilian Patent and Regulatory System&type=mp3",
              name: "Intro to Brazil",
            },
            ...new Array(2).fill(null),
            {
              path: "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?type=mp3&id=Introduction%20to%20Indian%20Patent%20and%20Regulatory%20System",
              name: "Intro to India",
            },
            {
              path: "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?type=mp3&id=Introduction%20to%20Korean%20Patent%20and%20Regulatory%20System",
              name: "Intro to Korea",
            },
            {
              path: "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?type=mp3&id=Introduction%20to%20Chinese%20Patent%20and%20Regulatory%20System",
              name: "Intro to China",
            },
            ...new Array(2).fill(null),
          ],
        },
        Biologics: {
          images: [
            "LifeCycleInsightsBiologicsPharma.png",
            "LifeCycleInsightsBiologicsPharma2.png",
            "LifeCycleInsightsBiologicsPharma3.png",
            "LifeCycleInsightsBiologicsPharma4.png",
            "LifeCycleInsightsBiologicsPharma5.png",
            "LifeCycleInsightsBiologicsPharma6.png",
            "LifeCycleInsightsBiologicsPharma7.png",
            "LifeCycleInsightsBiologicsPharma8.png",
            "LifeCycleInsightsBiologicsPharma9.png",
            "LifeCycleInsightsBiologicsPharma10.png",
            "LifeCycleInsightsBiologicsPharma11.png",
            "LifeCycleInsightsBiologicsPharma12.png",
            "LifeCycleInsightsBiologicsPharma13.png",
          ],
          brochures: [
            {
              path: "IPDAnalytics_LifeCycleInsights.pdf",
              name: "Full",
            },
            ...new Array(11).fill(null),
            {
              path: "IPDAnalytics_LifeCycleInsights.pdf",
              name: "Full",
            },
          ],
          podcasts: [
            ...new Array(3).fill(null),
            {
              path:
                "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?id=Introduction to Canadian Patent and Regulatory System&type=mp3",
              name: "Intro to Canada",
            },
            {
              path:
                "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?id=Introduction to Japanese Patent and Regulatory System&type=mp3",
              name: "Intro to Japan",
            },
            {
              path:
                "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?id=Introduction to Brazilian Patent and Regulatory System&type=mp3",
              name: "Intro to Brazil",
            },
            ...new Array(2).fill(null),
            {
              path: "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?type=mp3&id=Introduction%20to%20Indian%20Patent%20and%20Regulatory%20System",
              name: "Intro to India",
            },
            {
              path: "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?type=mp3&id=Introduction%20to%20Korean%20Patent%20and%20Regulatory%20System",
              name: "Intro to Korea",
            },
            {
              path: "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?type=mp3&id=Introduction%20to%20Chinese%20Patent%20and%20Regulatory%20System",
              name: "Intro to China",
            },
            ...new Array(2).fill(null),
          ],
        },
        "Payor & Provider": {
          images: ["SuppliersPayorandProviderInsights.png"],
          brochures: ["IPDAnalytics_Payer_and_Provider_Insights_Payer.pdf"],
        },
        "Payer & Provider": {
          images: ["SuppliersPayorandProviderInsights.png"],
          brochures: ["IPDAnalytics_Payer_and_Provider_Insights_Payer.pdf"],
        },
        Forecasting: {
          images: [
            "ForecastingPopups1.png",
            "ForecastingPopups2.png",
            "ForecastingPopups3.png",
            "ForecastingPopups4.png",
            "ForecastingPopups5.png",
          ],
          brochures: ["IPDAnalytics_MarketandFinancialInsightsBrochure.pdf"],
        },
        "Coding & Reimbursement": {
          images: [
            "SuppliersCODESOURxCE.png",
            "SuppliersCODESOURxCE2.png",
            "SuppliersCODESOURxCE3.png",
            "SuppliersCODESOURxCE4.png",
            "SuppliersCODESOURxCE5.png",
          ],
          brochures: ["IPDAnalytics_Suppliers_CODESOURxCE.pdf"],
        },
        "Budget Impact": {
          images: [
            "BudgetImpactPopups1.png",
            "BudgetImpactPopups2.png",
            "BudgetImpactPopups3.png",
            "BudgetImpactPopups4.png",
          ],
          brochures: ["IPDAnalytics_BudgetImpact.pdf"],
        },
      },
    },
  },
  Manufacturer: {
    "Branded Pharma": {
      All: {
        folder: "Manufacturer - Branded Pharma/",
        Pharma: {
          images: [
            "LifeCycleInsightsBiologicsPharma.png",
            "LifeCycleInsightsBiologicsPharma2.png",
            "LifeCycleInsightsBiologicsPharma3.png",
            "LifeCycleInsightsBiologicsPharma4.png",
            "LifeCycleInsightsBiologicsPharma5.png",
            "LifeCycleInsightsBiologicsPharma6.png",
            "LifeCycleInsightsBiologicsPharma7.png",
            "LifeCycleInsightsBiologicsPharma8.png",
            "LifeCycleInsightsBiologicsPharma9.png",
            "LifeCycleInsightsBiologicsPharma10.png",
            "LifeCycleInsightsBiologicsPharma11.png",
            "LifeCycleInsightsBiologicsPharma12.png",
            "LifeCycleInsightsBiologicsPharma13.png",
          ],
          brochures: [
            {
              path: "IPDAnalytics_LifeCycleInsights.pdf",
              name: "Full",
            },
            ...new Array(11).fill(null),
            {
              path: "IPDAnalytics_LifeCycleInsights.pdf",
              name: "Full",
            },
          ],
          podcasts: [
            ...new Array(3).fill(null),
            {
              path:
                "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?id=Introduction to Canadian Patent and Regulatory System&type=mp3",
              name: "Intro to Canada",
            },
            {
              path:
                "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?id=Introduction to Japanese Patent and Regulatory System&type=mp3",
              name: "Intro to Japan",
            },
            {
              path:
                "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?id=Introduction to Brazilian Patent and Regulatory System&type=mp3",
              name: "Intro to Brazil",
            },
            ...new Array(2).fill(null),
            {
              path: "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?type=mp3&id=Introduction%20to%20Indian%20Patent%20and%20Regulatory%20System",
              name: "Intro to India",
            },
            {
              path: "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?type=mp3&id=Introduction%20to%20Korean%20Patent%20and%20Regulatory%20System",
              name: "Intro to Korea",
            },
            {
              path: "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?type=mp3&id=Introduction%20to%20Chinese%20Patent%20and%20Regulatory%20System",
              name: "Intro to China",
            },
            ...new Array(2).fill(null),
          ],
        },
        Biologics: {
          images: [
            "LifeCycleInsightsBiologicsPharma.png",
            "LifeCycleInsightsBiologicsPharma2.png",
            "LifeCycleInsightsBiologicsPharma3.png",
            "LifeCycleInsightsBiologicsPharma4.png",
            "LifeCycleInsightsBiologicsPharma5.png",
            "LifeCycleInsightsBiologicsPharma6.png",
            "LifeCycleInsightsBiologicsPharma7.png",
            "LifeCycleInsightsBiologicsPharma8.png",
            "LifeCycleInsightsBiologicsPharma9.png",
            "LifeCycleInsightsBiologicsPharma10.png",
            "LifeCycleInsightsBiologicsPharma11.png",
            "LifeCycleInsightsBiologicsPharma12.png",
            "LifeCycleInsightsBiologicsPharma13.png",
          ],
          brochures: [
            {
              path: "IPDAnalytics_LifeCycleInsights.pdf",
              name: "Full",
            },
            ...new Array(11).fill(null),
            {
              path: "IPDAnalytics_LifeCycleInsights.pdf",
              name: "Full",
            },
          ],
          podcasts: [
            ...new Array(3).fill(null),
            {
              path:
                "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?id=Introduction to Canadian Patent and Regulatory System&type=mp3",
              name: "Intro to Canada",
            },
            {
              path:
                "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?id=Introduction to Japanese Patent and Regulatory System&type=mp3",
              name: "Intro to Japan",
            },
            {
              path:
                "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?id=Introduction to Brazilian Patent and Regulatory System&type=mp3",
              name: "Intro to Brazil",
            },
            ...new Array(2).fill(null),
            {
              path: "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?type=mp3&id=Introduction%20to%20Indian%20Patent%20and%20Regulatory%20System",
              name: "Intro to India",
            },
            {
              path: "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?type=mp3&id=Introduction%20to%20Korean%20Patent%20and%20Regulatory%20System",
              name: "Intro to Korea",
            },
            {
              path: "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?type=mp3&id=Introduction%20to%20Chinese%20Patent%20and%20Regulatory%20System",
              name: "Intro to China",
            },
            ...new Array(2).fill(null),
          ],
        },
        "Payor & Provider": {
          images: ["BrandedPayorandProviderInsights.png"],
          brochures: ["IPDAnalytics_Branded_PayorProviderInsights.pdf"],
        },
        "Payer & Provider": {
          images: ["BrandedPayorandProviderInsights.png"],
          brochures: ["IPDAnalytics_Branded_PayorProviderInsights.pdf"],
        },
        Forecasting: {
          images: [
            "ForecastingPopups1.png",
            "ForecastingPopups2.png",
            "ForecastingPopups3.png",
            "ForecastingPopups4.png",
            "ForecastingPopups5.png",
          ],
          brochures: ["IPDAnalytics_MarketandFinancialInsightsBrochure.pdf"],
        },
        "Coding & Reimbursement": {
          images: [
            "BrandedCODESOURxCE.png",
            "BrandedCODESOURxCE2.png",
            "BrandedCODESOURxCE3.png",
            "BrandedCODESOURxCE4.png",
          ],
          brochures: ["IPDAnalytics_CODESOURxCEBranded.pdf"],
        },
        "Budget Impact": {
          images: [
            "BudgetImpactPopups1.png",
            "BudgetImpactPopups2.png",
            "BudgetImpactPopups3.png",
            "BudgetImpactPopups4.png",
          ],
          brochures: ["IPDAnalytics_BudgetImpact.pdf"],
        },
      },
    },
    "Generic & Alternative Competitors": {
      All: {
        folder: "Manufacturer - Generic & Alternative Competitors/",
        Pharma: {
          images: [
            "LifeCycleInsightsBiologicsPharma.png",
            "LifeCycleInsightsBiologicsPharma2.png",
            "LifeCycleInsightsBiologicsPharma3.png",
            "LifeCycleInsightsBiologicsPharma4.png",
            "LifeCycleInsightsBiologicsPharma5.png",
            "LifeCycleInsightsBiologicsPharma6.png",
            "LifeCycleInsightsBiologicsPharma7.png",
            "LifeCycleInsightsBiologicsPharma8.png",
            "LifeCycleInsightsBiologicsPharma9.png",
            "LifeCycleInsightsBiologicsPharma10.png",
            "LifeCycleInsightsBiologicsPharma11.png",
            "LifeCycleInsightsBiologicsPharma12.png",
            "LifeCycleInsightsBiologicsPharma13.png",
          ],
          brochures: [
            {
              path: "IPDAnalytics_LifeCycleInsights.pdf",
              name: "Full",
            },
            ...new Array(11).fill(null),
            {
              path: "IPDAnalytics_LifeCycleInsights.pdf",
              name: "Full",
            },
          ],
          podcasts: [
            ...new Array(3).fill(null),
            {
              path:
                "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?id=Introduction to Canadian Patent and Regulatory System&type=mp3",
              name: "Intro to Canada",
            },
            {
              path:
                "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?id=Introduction to Japanese Patent and Regulatory System&type=mp3",
              name: "Intro to Japan",
            },
            {
              path:
                "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?id=Introduction to Brazilian Patent and Regulatory System&type=mp3",
              name: "Intro to Brazil",
            },
            ...new Array(2).fill(null),
            {
              path: "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?type=mp3&id=Introduction%20to%20Indian%20Patent%20and%20Regulatory%20System",
              name: "Intro to India",
            },
            {
              path: "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?type=mp3&id=Introduction%20to%20Korean%20Patent%20and%20Regulatory%20System",
              name: "Intro to Korea",
            },
            {
              path: "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?type=mp3&id=Introduction%20to%20Chinese%20Patent%20and%20Regulatory%20System",
              name: "Intro to China",
            },
            ...new Array(2).fill(null),
          ],
        },
        Biologics: {
          images: [
            "LifeCycleInsightsBiologicsPharma.png",
            "LifeCycleInsightsBiologicsPharma2.png",
            "LifeCycleInsightsBiologicsPharma3.png",
            "LifeCycleInsightsBiologicsPharma4.png",
            "LifeCycleInsightsBiologicsPharma5.png",
            "LifeCycleInsightsBiologicsPharma6.png",
            "LifeCycleInsightsBiologicsPharma7.png",
            "LifeCycleInsightsBiologicsPharma8.png",
            "LifeCycleInsightsBiologicsPharma9.png",
            "LifeCycleInsightsBiologicsPharma10.png",
            "LifeCycleInsightsBiologicsPharma11.png",
            "LifeCycleInsightsBiologicsPharma12.png",
            "LifeCycleInsightsBiologicsPharma13.png",
          ],
          brochures: [
            {
              path: "IPDAnalytics_LifeCycleInsights.pdf",
              name: "Full",
            },
            ...new Array(11).fill(null),
            {
              path: "IPDAnalytics_LifeCycleInsights.pdf",
              name: "Full",
            },
          ],
          podcasts: [
            ...new Array(3).fill(null),
            {
              path:
                "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?id=Introduction to Canadian Patent and Regulatory System&type=mp3",
              name: "Intro to Canada",
            },
            {
              path:
                "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?id=Introduction to Japanese Patent and Regulatory System&type=mp3",
              name: "Intro to Japan",
            },
            {
              path:
                "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?id=Introduction to Brazilian Patent and Regulatory System&type=mp3",
              name: "Intro to Brazil",
            },
            ...new Array(2).fill(null),
            {
              path: "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?type=mp3&id=Introduction%20to%20Indian%20Patent%20and%20Regulatory%20System",
              name: "Intro to India",
            },
            {
              path: "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?type=mp3&id=Introduction%20to%20Korean%20Patent%20and%20Regulatory%20System",
              name: "Intro to Korea",
            },
            {
              path: "https://secure.ipdanalytics.com/User/Pharma/RxStrategy/Podcast/Episode/Download?type=mp3&id=Introduction%20to%20Chinese%20Patent%20and%20Regulatory%20System",
              name: "Intro to China",
            },
            ...new Array(2).fill(null),
          ],
        },
        "Payor & Provider": {
          images: ["GenericPayorandProviderInsights.png"],
          brochures: ["IPDAnalytics_Generics_PayorInsights.pdf"],
        },
        "Payer & Provider": {
          images: ["GenericPayorandProviderInsights.png"],
          brochures: ["IPDAnalytics_Generics_PayorInsights.pdf"],
        },
        Forecasting: {
          images: [
            "ForecastingPopups1.png",
            "ForecastingPopups2.png",
            "ForecastingPopups3.png",
            "ForecastingPopups4.png",
            "ForecastingPopups5.png",
          ],
          brochures: ["IPDAnalytics_MarketandFinancialInsightsBrochure.pdf"],
        },
        "Coding & Reimbursement": {
          images: [
            "GenericsCODESOURxCE.png",
            "GenericsCODESOURxCE2.png",
            "GenericsCODESOURxCE3.png",
            "GenericsCODESOURxCE4.png",
            "GenericsCODESOURxCE5.png",
          ],
          brochures: ["IPDAnalytics_CODESOURxCEGenerics.pdf"],
        },
        "Budget Impact": {
          images: [
            "BudgetImpactPopups1.png",
            "BudgetImpactPopups2.png",
            "BudgetImpactPopups3.png",
            "BudgetImpactPopups4.png",
          ],
          brochures: ["IPDAnalytics_BudgetImpact.pdf"],
        },
      },
    },
  },
  "Wall Street": {
    All: {
      All: {
        folder: "Wall Street/",
        Pharma: {
          images: [
            "InstitutionalInvestorsPharmaBiologics.png",
            "InstitutionalInvestorsPharmaBiologics2.png",
          ],
          brochures: [
            "IPD Analytics_Institutional InvestorsUSGlobalPharmaBiologics.pdf",
          ],
        },
        Biologics: {
          images: [
            "Learn More Popups_Life Cycle Insights_Biologics_US_Global_Institutional Investors.png",
            "Learn More Popups_Life Cycle Insights_Biologics_US_Global_Institutional Investors2.png",
          ],
          brochures: [
            "IPD Analytics_Institutional InvestorsUSGlobalPharmaBiologics.pdf",
          ],
        },
        "Tech Media": {
          images: ["InstitutionalInvestorsTechMedia.png"],
          brochures: [""],
        },
        "Medical Technology": {
          images: ["InstitutionalInvestorsMedTech.png"],
          brochures: [""],
        },
        "Payor & Provider": {
          images: [
            "InstitutionalInvestorsPayorandProviderInsights.png",
            "InstitutionalInvestorsPayorandProviderInsights2.png",
          ],
          brochures: [
            "IPDAnalytics_PayorandProviderInsights_InstitutionalInvestors.pdf",
          ],
        },
        "Payer & Provider": {
          images: [
            "InstitutionalInvestorsPayorandProviderInsights.png",
            "InstitutionalInvestorsPayorandProviderInsights2.png",
          ],
          brochures: [
            "IPDAnalytics_PayorandProviderInsights_InstitutionalInvestors.pdf",
          ],
        },
        Forecasting: {
          images: [
            "ForecastingPopups1.png",
            "ForecastingPopups2.png",
            "ForecastingPopups3.png",
            "ForecastingPopups4.png",
            "ForecastingPopups5.png",
          ],
          brochures: ["IPDAnalytics_MarketandFinancialInsightsBrochure.pdf"],
        },
      },
    },
  },
  Other: {
    "EU+SPC Tracker": {
      images: ["SpcTracker1.png", "SpcTracker2.png", "SpcTracker3.png"],
      brochures: ["IPDAnalytics_SpcTracker.pdf"],
    },
  },
};

export const BYPASS_PRODUCT_NAMES = ["EU+SPC Tracker"];

const categorySwitch = (majorCategory, minorCategory, subClass) => {
  // logical overrides for minorCategory and subClass depending on majorCategory to match the learnMoreMap
  switch (majorCategory) {
    case "Main Street":
      if (minorCategory === "Supply Chain") subClass = "All";
      break;
    case "Manufacturer":
      subClass = "All";
      break;
    case "Wall Street":
      minorCategory = "All";
      subClass = "All";
      break;
    default:
      majorCategory = "Main Street";
      minorCategory = "Payer & Provider";
      subClass = "Hospital";
      break;
  }
  return { major: majorCategory, minor: minorCategory, sub: subClass };
};

export const getImages = (
  majorCategory,
  minorCategory,
  subClass,
  productName
) => {
  // handle redirect from LCI Homepage to bypass checks and directly load images
  if (BYPASS_PRODUCT_NAMES.includes(productName)) {
    return learnMoreMap["Other"][productName].images.map(
      (i) => `other/${productName}/${i}`
    );
  }

  const { major, minor, sub } = categorySwitch(
    majorCategory,
    minorCategory,
    subClass
  );

  if (productName.match(/^Specialized Litigation Coverage/i)) {
    // no images, it's a URL call to get a Markdown description
    return getData(
      `${settings.API_LITIGATION}/description?product=${encodeURIComponent(
        productName
      )}`
    ).then((x) => ({ type: "markdown", value: x.description }));
  }

  const learnMore =
    learnMoreMap[major] &&
    learnMoreMap[major][minor] &&
    learnMoreMap[major][minor][sub];
  const folder = learnMore.folder;
  const images = learnMore[productName] && learnMore[productName].images;
  if (!images || isEmpty(images)) return [];
  return images.map((x) => `${folder}${x}`);
};

export const getBrochures = (
  majorCategory,
  minorCategory,
  subClass,
  productName
) => {
  // handle redirect from LCI Homepage to bypass checks and directly load brochures
  if (BYPASS_PRODUCT_NAMES.includes(productName)) {
    return learnMoreMap["Other"][productName].brochures.map((i) => ({
      name: productName,
      path: `other/${productName}/${i}`,
    }));
  }
  const { major, minor, sub } = categorySwitch(
    majorCategory,
    minorCategory,
    subClass
  );
  if (productName.match(/^Specialized Litigation Coverage/i)) return [];

  const learnMore =
    learnMoreMap[major] &&
    learnMoreMap[major][minor] &&
    learnMoreMap[major][minor][sub];
  const folder = learnMore.folder;
  const brochures = learnMore[productName] && learnMore[productName].brochures;
  if (!brochures || isEmpty(brochures)) return [];

  return brochures.map((x) => {
    if (x) {
      if (typeof x === "string") return `${folder}${x}`;
      if (typeof x === "object" && x.path)
        return { ...x, path: `${folder}${x.path}` };
    }
    return x;
  });
};

export const getPodcasts = (
  majorCategory,
  minorCategory,
  subClass,
  productName
) => {
  // handle redirect from LCI Homepage to bypass checks and directly load podcasts
  if (BYPASS_PRODUCT_NAMES.includes(productName)) {
    return learnMoreMap["Other"][productName].podcasts || [];
  }

  const { major, minor, sub } = categorySwitch(
    majorCategory,
    minorCategory,
    subClass
  );
  if (productName.match(/^Specialized Litigation Coverage/i)) return [];

  const learnMore =
    learnMoreMap[major] &&
    learnMoreMap[major][minor] &&
    learnMoreMap[major][minor][sub];
  const podcasts = learnMore[productName] && learnMore[productName].podcasts;
  if (!podcasts || isEmpty(podcasts)) return [];

  return podcasts;
};

export const accountTypeCanHaveProduct = (
  majorCategory,
  minorCategory,
  subClass,
  productName,
  groupName
) => {
  if (groupName && groupName.match(/^Specialized Litigation Coverage$/i))
    return true; // everyone has access, but it's not in learn more

  const { major, minor, sub } = categorySwitch(
    majorCategory,
    minorCategory,
    subClass
  );
  const learnMore =
    learnMoreMap[major] &&
    learnMoreMap[major][minor] &&
    learnMoreMap[major][minor][sub];
  return !learnMore || isEmpty(learnMore)
    ? false
    : Object.keys(learnMore).includes(productName);
};
